import { DataSet } from '../../engenharia/projetos/projetos-layout/projetos-layout.model';
import { HttpService } from '../../../services/common/http/common.http.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { formatDate } from '../../../utils/utility-functions';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-planejamento-layout',
  templateUrl: './planejamento-layout.component.html',
  styleUrls: ['./planejamento-layout.component.scss'],
})
export class PlanejamentoLayoutComponent implements OnInit {
  tableData: any[] = [];
  expandirCardsMobile: boolean = false;
  loader: boolean = false;

  constructor(private httpService: HttpService, private router: Router) {}

  ngOnInit() {
    this.getDiarios();
  }

  pesquisaParams = {
    TxPesquisar: '',
    DtDiario: '',
    IsExport: false,
    Pagina: 0,
    TamanhoPagina: 8,
    MaxPages: 1,
  };

  tableColumns = [
    { header: 'Nome da Obra', key: 'nomeObra', type: 'text' },
    { header: 'Responsável', key: 'responsavel', type: 'text' },
    { header: 'Local', key: 'local', type: 'text' },
    { header: 'Conclusão', key: 'conclusao', type: 'text' },
    { header: 'Data', key: 'data', type: 'text' },
    {
      header: 'Diários',
      key: 'diarios',
      type: 'buttons',
      buttons: [
        {
          label: 'Visualizar',
          action: (item: any) => this.editItem(item),
          condition: (item: any) => true,
        },
      ],
    },
    {
      header: 'Ações',
      key: 'actions',
      type: 'buttons',
      buttons: [
        {
          label: 'Editar',
          img: 'assets/images/edit.svg',
          action: (item: any) => this.editItem(item),
          condition: (item: any) => true,
        },
        {
          label: 'Deletar',
          img: 'assets/images/del.svg',
          action: (item: any) => this.deleteDiario(item),
          condition: (item: any) => true,
        },
      ],
    },
  ];

  rowsMobile = [
    { header: 'Nome da Obra', key: 'nomeObra', type: 'text', default: true },
    { header: 'Responsável', key: 'responsavel', type: 'text', default: true },
    { header: 'Local', key: 'local', type: 'text' },
    { header: 'Conclusão', key: 'conclusao', type: 'text', default: true },
    { header: 'Data', key: 'data', type: 'text', default: true },
    {
      header: 'Diários',
      key: 'diarios',
      type: 'buttons',
      buttons: [
        {
          label: 'Visualizar',
          action: (item: any) => this.editItem(item),
          condition: (item: any) => true,
        },
      ],
    },
    {
      header: 'Ações',
      key: 'acoes',
      type: 'buttons',
      buttons: [
        {
          img: 'assets/images/edit.svg',
          label: 'Editar',
          action: (item: any) => this.editItem(item),
          condition: (item: any) => true,
        },
        {
          img: 'assets/images/del.svg',
          label: 'Deletar',
          action: (item: any) => this.deleteDiario(item),
          condition: (item: any) => true,
        },
      ],
    },
  ];

  getDiarios() {
    this.loader = true;
    this.httpService
      .useGet('DiarioObraByFilter', this.pesquisaParams)
      .subscribe({
        next: (res: any) => {
          if (!res.IsSuccess) this.tableData = [];
          this.tableData = res.DataSet.map((item: any) => {
            return {
              id: item.IdObra,
              nomeObra: item.NmObra,
              local: item.TxEndereco ?? 'Não informado',
              responsavel: item.NmFuncionario,
              data: formatDate(item.DtObra),
              conclusao: `${item.QtConclusao}% concluída`,
            };
          });
        },
        error: (err: any) => {},
        complete: () => {
          this.loader = false;
        },
      });
  }

  editItem(item: any) {
    const params = {
      ...item,
      isEditing: true,
    };
    this.router.navigate(['planejamento/diario'], {
      queryParams: params,
    });
  }

  deleteDiario(item: any): void {
    const id = item.id;
    const body = {
      NuStatusDiarioObra: 3,
    };
    Swal.fire({
      title: 'Atenção!',
      text: 'Deseja realmente excluir o diário de obra?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: 'green',
      confirmButtonText: 'Sim',
      cancelButtonColor: 'red',
      cancelButtonText: 'Não',
    }).then((result) => {
      this.loader = true;
      if (result.isConfirmed) {
        this.httpService.usePatch('DiarioObraStatus', body, id).subscribe({
          next: (res: any) => {
            Swal.fire({
              title: 'Sucesso!',
              text: 'Diário de obra excluído com sucesso.',
              icon: 'success',
              confirmButtonText: 'Ok',
              confirmButtonColor: 'green',
            }).then(() => {
              this.getDiarios();
            });
          },
          error: (err: any) => {
            Swal.fire({
              title: 'Erro!',
              text: 'Erro ao excluir o diário de obra.',
              icon: 'error',
              confirmButtonText: 'Ok',
              confirmButtonColor: 'red',
            });
          },
          complete: () => {
            this.loader = false;
          },
        });
      }
      this.loader = false;
    });
  }

  exportExcel() {
    this.pesquisaParams.IsExport = true;
    this.getDiarios();
    this.pesquisaParams.IsExport = false;
  }

  timer: ReturnType<typeof setTimeout> | null = null;
  onChangeSearch() {
    if (this.timer !== null) {
      clearTimeout(this.timer);
    }

    this.timer = setTimeout(() => {
      this.getDiarios();
    }, 800);
  }

  mudarPagina(pagina: number) {
    this.pesquisaParams.Pagina = pagina;
    this.getDiarios();
  }

  navigateRegistrarDiario() {
    this.router.navigate(['planejamento/diario']);
  }
}
